module.exports = __webpack_public_path__ + "static/top_left-47b5df0ece4f0e419532cdcafa29f288.png";